import { eventMinute, targetLabel, AUTO_RED } from "@/lib/events";
import { teamStyle } from "@/lib/colors";

export const expulsions = (match) => {
  const field = Object.fromEntries(["home", "away"].map((s) => [s, new Set(match[s].players.filter((p) => p.starter).map((p) => String(p.number)))]));
  const list = [];
  [...match.events].sort((a, b) => a.created_at.localeCompare(b.created_at)).forEach((e) => {
    if (!e.team) return;
    const f = field[e.team];
    if (e.type === "substituicao") { f.delete(e.target); f.add(e.player_in); }
    if (e.type !== "vermelho") return;
    const player = e.target_type === "player";
    const wasOn = player && f.delete(e.target);
    list.push({ e, player, wasOn, remaining: player ? f.size : null, reason: e.note === AUTO_RED ? "2º amarelo" : "Vermelho direto" });
  });
  return list;
};

export const expulsionRows = (m) =>
  expulsions(m).map((x) => [eventMinute(x.e, m.half2_reset), m[x.e.team].name, x.e.target ? targetLabel(x.e) : "Sem identificação", x.reason,
    x.player ? (x.wasOn ? `${x.remaining} em campo` : "Não estava em campo") : x.e.target_type === "official" ? "Oficial" : "—"]);

export const ExpulsionsSummary = ({ match }) => {
  const list = expulsions(match);
  if (!list.length) return <p data-testid="expulsions-empty" className="text-sm text-zinc-500">Sem expulsões neste jogo.</p>;
  return (
    <ol data-testid="expulsions-summary" className="border border-white/15 bg-[#131313] divide-y divide-white/10">
      {list.map((x, i) => (
        <li key={x.e.id} data-testid={`expulsion-${i + 1}`} className="flex flex-wrap items-center gap-x-4 gap-y-1 px-4 py-3 text-sm">
          <span className="w-16 font-display text-xl font-bold tabular-nums">{eventMinute(x.e, match.half2_reset)}</span>
          <span style={teamStyle(match[x.e.team])} className="px-2 py-0.5 font-display font-bold uppercase truncate max-w-[40%]">{match[x.e.team].name}</span>
          <span className="font-semibold">{x.e.target ? targetLabel(x.e) : "Sem identificação"}</span>
          <span className="text-[#FF3B30]">{x.reason}</span>
          <span data-testid={`expulsion-${i + 1}-remaining`} className="ml-auto text-zinc-400">
            {x.player ? (x.wasOn ? `Ficou com ${x.remaining} em campo` : "Não estava em campo") : x.e.target_type === "official" ? "Elemento oficial" : "—"}
          </span>
        </li>
      ))}
    </ol>
  );
};
